import { useTranslation } from 'react-i18next';
import { statusInfo } from '../utils/constants.js';

export default function StatusBadge({ status }) {
    const { t } = useTranslation();
    const { label, tone } = statusInfo(status, t);
    return <span className={`badge badge-${tone}`}>{label}</span>;
}
